var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ads-horizontal"},[_c('google1x1'),(!_vm.isMobile)?_c('google-profile-horizontal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }